module.exports = __webpack_public_path__ + "img/fr.4fbe728b.png";